import axios from 'axios';
import {session} from "@/utils/session"

export default {
    namespaced: true,
    state: {
        ip_server: (location.hostname === 'localhost' || location.hostname === '192.168.0.3') ? 'http://192.168.0.3:7908' : '//' + location.host,
        http_common: ""
    },
    getters: {
        getIpServer: (state) => {
            return state.ip_server;
        }
    },
    mutations: {
        SET_HTTP_COMMON(state, http) {
            state.http_common = http
        },
    },

    actions: {
        setInitHttp({state, commit},self) {
            const http = axios.create({
                baseURL: state.ip_server + '/api/v2/autofacturador/',
                headers: {
                    'Content-Type': 'application/json',
                }
            });

            http.interceptors.request.use((config) => {
                let token = session.getValue('token');
                if (token) {
                    config.headers = {'X-autofacturatoken': token};
                }
                return config
            }, (error) => {
                return Promise.reject(error)
            });

            http.interceptors.response.use((response) => {
                return response
            }, (error) => {
                if (error.response.status === 401) {
                    let token = session.getValue('token');
                    if (token) {
                        session.remove();
                        self.$bvModal.msgBoxOk("Por favor ingrese folio de nota y código para facturar", {
                            title: 'Sesión expirada',
                            size: 'sm',
                            buttonSize: 'sm',
                            okVariant: 'primary',
                            headerClass: 'p-2 border-bottom-0',
                            footerClass: 'p-2 border-top-0',
                            centered: true
                        }).then(() => {
                            location.hash = "/invoice/search-note"
                        });
                    }


                }
                return Promise.reject(error)
            });
            commit('SET_HTTP_COMMON', http);
            console.log("--------SET_HTTP_INIT------------")
        },

    }

}
